import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import { initialMasterQuickReplyTemplateState } from "./defaultState";
import {
  FETCH_MASTER_QUICK_REPLY_TEMPLATE_LIST_PROGRESS,
  FETCH_MASTER_QUICK_REPLY_TEMPLATE_LIST_SUCCESS,
  FETCH_MASTER_QUICK_REPLY_TEMPLATE_LIST_FAILED,
  FETCH_MASTER_QUICK_REPLY_TEMPLATE_PROGRESS,
  FETCH_MASTER_QUICK_REPLY_TEMPLATE_SUCCESS,
  FETCH_MASTER_QUICK_REPLY_TEMPLATE_FAILED,
  CLEAR_MASTER_QUICK_REPLY_TEMPLATE_STATE,
  CLEAR_MASTER_QUICK_REPLY_TEMPLATE,
} from "./masterQuickReplyTemplateAction";

export const masterQuickReplyTemplateReducer = (
  state: IStoreState["masterQuickReplyTemplate"] = initialMasterQuickReplyTemplateState,
  action: any
) => {
  switch (action.type) {
    // List Actions
    case FETCH_MASTER_QUICK_REPLY_TEMPLATE_LIST_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.list = [];
        draftState.list.totalRecords = 0;
      });
    }

    case FETCH_MASTER_QUICK_REPLY_TEMPLATE_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.list = data;
        draftState.list.totalRecords = totalRecords;
        draftState.list.error = null;
      });
    }

    case FETCH_MASTER_QUICK_REPLY_TEMPLATE_LIST_FAILED: {
      const { errorMessage } = action?.payload || "Something went wrong";
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.Failed;
        draftState.list.error = errorMessage || "Something went wrong";
      });
    }
    case FETCH_MASTER_QUICK_REPLY_TEMPLATE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.masterQuickReplyTemplateData.loading = LoadState.InProgress;
        draftState.masterQuickReplyTemplateData.data =
          initialMasterQuickReplyTemplateState.masterQuickReplyTemplateData.data;
      });
      return newState;
    }
    case FETCH_MASTER_QUICK_REPLY_TEMPLATE_SUCCESS: {
      const { data } = action.payload;

      const newState = produce(state, (draftState) => {
        draftState.masterQuickReplyTemplateData.loading = LoadState.Loaded;
        draftState.masterQuickReplyTemplateData.data = data;
      });

      return newState;
    }
    case FETCH_MASTER_QUICK_REPLY_TEMPLATE_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.masterQuickReplyTemplateData.loading = LoadState.Failed;
        draftState.masterQuickReplyTemplateData.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_MASTER_QUICK_REPLY_TEMPLATE_STATE: {
      return produce(state, (draftState) => {
        draftState.masterQuickReplyTemplateData = initialMasterQuickReplyTemplateState.masterQuickReplyTemplateData;
        draftState.masterQuickReplyTemplate = initialMasterQuickReplyTemplateState.masterQuickReplyTemplate;
      });
    }
    case CLEAR_MASTER_QUICK_REPLY_TEMPLATE: {
      return produce(state, (draftState) => {
        draftState.masterQuickReplyTemplateData = initialMasterQuickReplyTemplateState.masterQuickReplyTemplateData;
      });
    }
    default: {
      return state;
    }
  }
};
